/* eslint-disable jsx-a11y/anchor-is-valid */
import  {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {useSelector} from 'react-redux'
import { RootState } from "../../../setup/redux/RootReducer";
import StoreSelect from './components/StoreSelect'
import ProductList from './components/ProductList'
import ProductDetail  from './components/ProductDetail';


const ProductPage: FC = () => {
  const detailFlag:boolean=false;
  const currentStore = useSelector((state: RootState) => state.currentStoreReducer);
  const productDetailState = useSelector((state: RootState) => state.productDetailReducer);

  console.log("Current store =>>>",currentStore)
  return (
     <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
     {currentStore.store.storeNo  == 0 && productDetailState.productDetail.productId==0 &&
        <StoreSelect/>
     }
      {currentStore.store.storeNo != 0 && productDetailState.productDetail.productId==0 &&
        <div className='col-xxl-12' style={{marginTop:0}}>
          <ProductList/>
        </div>
      }
      {currentStore.store.storeNo != 0 && productDetailState.productDetail.productId!=0 &&
        <div className='col-xxl-12' style={{marginTop:0}}>
         <ProductDetail/>
       </div>
      }

      
    </div>
    {/* end::Row */}
  </>
  ) 
}

const ProductPageWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{"Ürün Servisi"}</PageTitle>
      <ProductPage />
    </>
  )
}

export {ProductPageWrapper}
